export const loginPath = "/api/login";

export const autoLoginPath = "/api/login/validate";

export const companyResumed = "/api/company/simple";

export const companyPlanPrice = "/api/company/getplanprice";

export const companyPlan = "/api/company/plan";

export const companyCountPath = "/api/company/count";

export const companyPath = "/api/company";

export const userPath = "/api/user";

export const userSimplePath = "/api/user/simple";

export const forgotPasswordPath = "/api/forgotpassword";

export const googlePath = "/api/google";

export const dedicatedPath = "/api/dedicated";

export const messagePath = "/api/message";

export const messageUserPath = messagePath + "/usermessage";

export const functionalityPath = "/api/functionality";

export const actionPath = "/api/action";

export const profilePath = "/api/profile";

export const planPath = "/api/plan";

export const planSimplePath = "/api/plan/simple";

export const companyDeletePath = "/api/companydelete";

export const emailPath = "/api/email";

export const paymentPath = "/api/payment";
export const paymentStatusPath = "/api/payment/status";
export const nfePath = "/api/nfe";

export const nfeDownloadPath = id => {
  return nfePath + "/" + id + "/download";
};

export const paymentRangePath = (init, end) => {
  return paymentPath + "/range/" + init + "/to/" + end;
};

export const paymentGeneratePath = "/api/payment/generate";

export const paymentResumePath = id => {
  return paymentPath + "/resume/" + id;
};

export const clientReportPath = "/api/report/sitecount";

export const cableSizeReportPath = "/api/report/cablesizereport";

export const ctoCountReportPath = "/api/report/ctocount";

export const ceoCountReportPath = "/api/report/ceocount";

export const erpPath = "/api/erp";

export const groupPagePath = "/api/grouppage";

export const pagePath = groupPageId => {
  return "/api/grouppage/" + groupPageId + "/page";
};

export const emailReportPath = "/api/email";

export const emailReportDatePath = (start, end) => {
  return emailReportPath + "/" + start + "/to/" + end;
};

export const sizeImagePath = "imageserver/size";

//-- CODEMAP --/
export const loginCodemaps = "/geo2/login/token";

export const companyPathCodemaps = "/geo2/company/admin";

export const userPathCodemaps = "/geo2/user/company";

export const userPathCodemapsPut = "/geo2/user";

export const profileCompanyCodemapsPath = "/geo2/profile/company";

export const profileMapsPath = "/geo2/profile";

export const folderMapsPath = "/geo2/folder/simple";

export const folderMapsDeletePath = "/geo2/folder/internal";

export const profileCompanyOneMapsPath = (companyId, id) => {
  return profileCompanyCodemapsPath + "/" + companyId + "/one/" + id;
};

export const forgotPasswordMapsPath = "/geo2/forgotpassword";

export const functionalityMapsPath = "/geo2/functionality";

export const actionMapsPath = "/geo2/action";

export const userAccessLogPath = companyId => {
  return "/geo2/user/admin/useraccess/" + companyId;
};

export const folderPath = "/api/folder";

export const logPath = "/api/changelog";

export const videochangelogPatch = changeLogId => {
  return logPath + "/" + changeLogId + "/videochangelog";
};

export const serverPath = "/api/server";

export const serverSimplePath = "/api/server/simple";

// export const extractServerPath = "/extractserver/extractkml/";

export const extractServerPath = "/geo2/extract";

export const eventPagePath = "/api/event/page/";
export const eventPath = "/api/event";
export const eventUserPath = "/api/event/user";

export const zipcodePath = "/api/zipcode";



// WEBPACK FOOTER //
// /src/router/ApiPaths.js